import { useParams, Link } from 'react-router-dom';
import { useEffect, useMemo, useState, useContext } from 'react';
import TradeOfferForm from '../components/TradeOfferForm';


import { db, auth } from '../firebase';
import { useContact } from '../contexts/ContactContext';
import { UserContext } from '../contexts/UserContext';
import {
  doc,
  getDoc,
  setDoc,
  updateDoc,
  arrayUnion,
  arrayRemove,
  collection,
  getDocs,
  query,
  where
} from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import { recordOfferIntentEvent, OFFER_INTENT_KINDS } from '../utils/offerIntentAnalytics';
import { usePedalMarketValues } from '../hooks/usePedalMarketValues';
import { getTradeBalance, formatBalanceLabel, getBalanceColors } from '../utils/tradeFairness';
import { placeholderFor, SKETCH_PLACEHOLDER_URL } from '../utils/listingPlaceholder';
import MatchCommentThread from '../components/MatchCommentThread';
import { matchKeyFor } from '../utils/matchThread';





const MatchDetails = () => {
  const { matchId } = useParams();
  const navigate = useNavigate();
  const { openContact } = useContact();
  const { shippingAddress, loading: userLoading } = useContext(UserContext);
const [myId, theirId] = matchId.split('_');

  const isAddressComplete = (address) => {
    if (!address) return false;
    const required = ['name', 'street1', 'city', 'state', 'zip', 'country'];
    return required.every(field => address[field] && address[field].trim());
  };

  const [matchPedal, setMatchPedal] = useState(null);
  const [myMatchingPedal, setMyMatchingPedal] = useState(null);
  const [balanceSuggestion, setBalanceSuggestion] = useState(0);
  const [myTotalPedalValue, setMyTotalPedalValue] = useState(0);
  const [myPedalCount, setMyPedalCount] = useState(1);
  const [myUserData, setMyUserData] = useState({ username: '', badge: null });
const [theirUserData, setTheirUserData] = useState({ username: '', badge: null });
const [theirUserId, setTheirUserId] = useState(null);
// True when the signed-in viewer owns one of the two listings. Admins and
// anyone on a shared link may read the page; only a party gets the comment
// composer (2026-11-01 review).
const [isViewerParty, setIsViewerParty] = useState(false);
// When the match document is gone but this viewer was a party to its comment
// thread, the thread is shown read-only under the "no longer available" card
// (2026-11-01 review: a removed match must not silently swallow a
// conversation). { key, usernames } or null.
const [orphanThread, setOrphanThread] = useState(null);
const [currentUser, setCurrentUser] = useState(null);
const [notLoggedIn, setNotLoggedIn] = useState(false);
const [additionalPedals, setAdditionalPedals] = useState([]);

// Market-based read on the trade, alongside the asking-price one. Asking prices
// are what sellers hope for; Reverb tiers are what the gear actually moves at.
const pricingPedals = useMemo(
  () => [myMatchingPedal, matchPedal, ...additionalPedals].filter(Boolean),
  [myMatchingPedal, matchPedal, additionalPedals]
);
const { marketTiers } = usePedalMarketValues(pricingPedals);
const marketBalance = useMemo(() => {
  if (!myMatchingPedal || !matchPedal) return null;
  const mine = [myMatchingPedal, ...additionalPedals].map((p) => marketTiers.get(p.id));
  return getTradeBalance(mine, marketTiers.get(matchPedal.id));
}, [myMatchingPedal, matchPedal, additionalPedals, marketTiers]);

const getTradeBadge = (count) => {
  if (count === undefined || count === null || isNaN(count)) return 0;
  return count; // Show exact number of completed trades, including 0
};

  const getMembershipBadge = (membershipTier) => {
    switch (membershipTier) {
      case 'premium_basic':
        return (
          <div className="flex items-center bg-blue-100 text-blue-800 px-2 py-1 rounded-full font-medium" style={{ fontSize: '12px' }}>
            <span className="bg-blue-600 text-white px-1.5 py-0.5 rounded font-bold mr-1" style={{ fontSize: '11px' }}>9V</span>
            Member
          </div>
        );
      case 'premium_plus':
        return (
          <div className="flex items-center bg-purple-100 text-purple-800 px-2 py-1 rounded-full font-medium" style={{ fontSize: '12px' }}>
            <span className="bg-purple-600 text-white px-1.5 py-0.5 rounded font-bold mr-1" style={{ fontSize: '11px' }}>18V</span>
            Member
          </div>
        );
      default:
        return (
          <div className="flex items-center bg-gray-100 text-gray-600 px-2 py-1 rounded-full font-medium" style={{ fontSize: '12px' }}>
            Free Member
          </div>
        );
    }
  };

const getMembershipProfileBadge = (membershipTier) => {
  switch (membershipTier) {
    case 'premium_basic':
      return (
        <div
          style={{
            position: 'absolute',
            top: '-4px',
            left: '-4px',
            backgroundColor: '#2563eb',
            color: 'white',
            fontWeight: 'bold',
            borderRadius: '4px',
            width: '20px',
            height: '12px',
            fontSize: '0.6rem',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            border: '1px solid #fff',
            boxShadow: '0 0 2px rgba(0,0,0,0.3)',
          }}
        >
          9V
        </div>
      );
    case 'premium_plus':
      return (
        <div
          style={{
            position: 'absolute',
            top: '-4px',
            left: '-4px',
            backgroundColor: '#7c3aed',
            color: 'white',
            fontWeight: 'bold',
            borderRadius: '4px',
            width: '20px',
            height: '12px',
            fontSize: '0.6rem',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            border: '1px solid #fff',
            boxShadow: '0 0 2px rgba(0,0,0,0.3)',
          }}
        >
          18V
        </div>
      );
    default:
      return null;
  }
};

const getMembershipTierText = (tier) => {
  switch (tier) {
    case 'premium_basic': return '9V';
    case 'premium_plus': return '18V';
    default: return 'Free';
  }
};

  let localMatchId = '';
if (myMatchingPedal && matchPedal) {
  localMatchId = `${myMatchingPedal.id}_${matchPedal.id}`;
}
const [isSaved, setIsSaved] = useState(false);

const handleSaveMatch = async () => {
  const user = auth.currentUser;
  if (!user) return;

  const userRef = doc(db, 'users', user.uid);
  const userSnap = await getDoc(userRef);

  const updatedMatchId = `${myMatchingPedal.id}_${matchPedal.id}`;

  if (!userSnap.exists()) {
    await setDoc(userRef, { savedMatches: [updatedMatchId] });
  } else {
    await updateDoc(userRef, {
      savedMatches: arrayUnion(updatedMatchId)
    });
  }

  setIsSaved(true);
  alert('Match saved!');
};
const handleUnsaveMatch = async () => {
  const user = auth.currentUser;
  if (!user) return;

  const updatedMatchId = `${myMatchingPedal.id}_${matchPedal.id}`;
  const userRef = doc(db, 'users', user.uid);

  await updateDoc(userRef, {
    savedMatches: arrayRemove(updatedMatchId)
  });

  setIsSaved(false);
  alert('Match unsaved.');
};




useEffect(() => {
  // Check auth state
  const unsubscribe = auth.onAuthStateChanged((user) => {
    setCurrentUser(user);
    if (!user) setNotLoggedIn(true);
  });

  return () => unsubscribe();
}, []);

useEffect(() => {
  // Wait for currentUser to be loaded before fetching match
  if (!currentUser) return;

  const fetchMatch = async () => {
    try {
      // Create composite match ID (matches what matchMaker.js creates)
      const sortedIds = [myId, theirId].sort();
      const compositeMatchId = `${sortedIds[0]}_${sortedIds[1]}`;
      
      // Try to fetch the match document directly using composite ID
      const matchDocRef = doc(db, 'matches', compositeMatchId);
      const matchDocSnap = await getDoc(matchDocRef);
      
      if (!matchDocSnap.exists()) {
        // Keep any conversation readable: parties may still read their
        // thread (rules), the composer stays closed.
        try {
          const threadSnap = await getDoc(doc(db, 'matchThreads', compositeMatchId));
          const t = threadSnap.exists() ? threadSnap.data() : null;
          if (t && Array.isArray(t.participants) && t.participants.includes(currentUser.uid) && Array.isArray(t.messages) && t.messages.length) {
            setOrphanThread({ key: compositeMatchId, participants: t.participants, usernames: t.usernames || {} });
          }
        } catch (threadErr) {
          console.warn('Orphaned match thread unavailable:', threadErr?.message || threadErr);
        }
        setError('This match is no longer available. The other user may have changed their listing or Wantlist preferences.');
        return;
      }
      
      // Now check if the listings still exist
      const mySnap = await getDoc(doc(db, 'listings', myId));
      const theirSnap = await getDoc(doc(db, 'listings', theirId));

      if (!mySnap.exists() || !theirSnap.exists()) {
        setError('This match is no longer available. One or more pedals have been removed or are no longer listed.');
        return;
      }

      // Sides come from OWNERSHIP, not URL order (2026-11-01 review). The
      // Matches list builds viewer-first URLs, but a shared link, a bell tap
      // on an older bundle, or the admin console's link may arrive flipped.
      // If the viewer owns the second listing, swap; if they own neither
      // (admin review) they are not a party and the composer stays hidden.
      let firstData = { id: myId, ...mySnap.data() };
      let secondData = { id: theirId, ...theirSnap.data() };
      if (secondData.ownerId === currentUser.uid && firstData.ownerId !== currentUser.uid) {
        const swap = firstData; firstData = secondData; secondData = swap;
      }
      setIsViewerParty(firstData.ownerId === currentUser.uid);
      const myPedal = firstData;
      const theirPedal = { uid: secondData.ownerId, ...secondData };

// PII isolation: counterparty cards read from public mirror.
const myUserSnap = await getDoc(doc(db, 'publicProfiles', myPedal.ownerId));
const theirUserSnap = await getDoc(doc(db, 'publicProfiles', theirPedal.ownerId));

const myUser = myUserSnap.exists() ? myUserSnap.data() : {};
const theirUser = theirUserSnap.exists() ? theirUserSnap.data() : {};

setMyUserData({
  username: myUser.username || 'Unknown',
  badge: getTradeBadge(myUser.completedTrades || 0),
  photoURL: myUser.photoURL || '/images/default-avatar.png',
  membershipTier: myUser.membershipTier || 'free',
  averageRating: myUser.averageRating || 0
});
setTheirUserData({
  username: theirUser.username || 'Unknown',
  badge: getTradeBadge(theirUser.completedTrades || 0),
  photoURL: theirUser.photoURL || '/images/default-avatar.png',
  membershipTier: theirUser.membershipTier || 'free',
  averageRating: theirUser.averageRating || 0,
  // For the inactive-owner heads-up on the trade form.
  lastActiveWeek: theirUser.lastActiveWeek || null
});

setTheirUserId(theirPedal.ownerId);

console.log('🔍 MATCH DETAILS - My user data:', {
  username: myUser.username || 'Unknown',
  badge: getTradeBadge(myUser.completedTrades || 0),
  photoURL: myUser.photoURL || '/images/default-avatar.png',
  membershipTier: myUser.membershipTier || 'free',
  averageRating: myUser.averageRating || 0
});
console.log('🔍 MATCH DETAILS - Their user data:', {
  username: theirUser.username || 'Unknown',
  badge: getTradeBadge(theirUser.completedTrades || 0),
  photoURL: theirUser.photoURL || '/images/default-avatar.png',
  membershipTier: theirUser.membershipTier || 'free',
  averageRating: theirUser.averageRating || 0
});


      setMyMatchingPedal(myPedal);
      setMatchPedal(theirPedal);

      const diff = Number(myPedal.price) - Number(theirPedal.price);
      setBalanceSuggestion(diff);
      setMyTotalPedalValue(Number(myPedal.price));
      setMyPedalCount(1);

      // Check if this match is saved
      const currentMatchId = `${myId}_${theirId}`;

      if (currentUser) {
        const userRef = doc(db, 'users', currentUser.uid);
        const userSnap = await getDoc(userRef);

        const saved = userSnap.exists() && (userSnap.data().savedMatches || []).includes(currentMatchId);
        setIsSaved(saved);
      }

    } catch (err) {
      console.error('Failed to load match details:', err);
      // Handle permission errors (match was deleted) or other errors
      if (err.code === 'permission-denied') {
        setError('This match is no longer available. The other user may have deleted their want or changed their match preferences.');
      } else {
        setError('Unable to load match details. Please try again later.');
      }
    }
  };

  fetchMatch();
}, [myId, theirId, currentUser]);



const [showOfferForm, setShowOfferForm] = useState(false);
const [error, setError] = useState(null);

  if (error) {
    return (
      <div style={{ 
        backgroundColor: '#F7F3EB', 
        minHeight: '100vh', 
        padding: '2rem',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: orphanThread ? 'flex-start' : 'center',
        gap: '1.5rem'
      }}>
        <div style={{
          backgroundColor: 'white',
          borderRadius: '12px',
          padding: '2rem',
          maxWidth: '600px',
          textAlign: 'center',
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
        }}>
          <h2 style={{ color: '#dc2626', fontSize: '1.5rem', fontWeight: 'bold', marginBottom: '1rem' }}>
            ⚠️ Match No Longer Available
          </h2>
          <p style={{ color: '#6b7280', marginBottom: '1.5rem', lineHeight: '1.6' }}>
            {error}
          </p>
          <Link 
            to="/matches" 
            style={{
              backgroundColor: '#5A9ECB',
              color: 'white',
              padding: '0.75rem 1.5rem',
              borderRadius: '9999px',
              textDecoration: 'none',
              display: 'inline-block',
              fontWeight: 'bold',
              fontFamily: 'Nunito, sans-serif',
              fontSize: '15px',
              transition: 'opacity 0.2s'
            }}
            onMouseEnter={(e) => e.target.style.opacity = '0.8'}
            onMouseLeave={(e) => e.target.style.opacity = '1'}
          >
            View Other Matches
          </Link>
        </div>
        {orphanThread && currentUser && (
          <div style={{ width: '100%', maxWidth: '600px' }}>
            <MatchCommentThread
              matchKey={orphanThread.key}
              currentUserId={currentUser.uid}
              theirUserId={orphanThread.participants.find((u) => u !== currentUser.uid) || null}
              myPedal={null}
              theirPedal={null}
              myUserData={{ username: orphanThread.usernames[currentUser.uid] || 'You' }}
              theirUserData={{ username: orphanThread.usernames[orphanThread.participants.find((u) => u !== currentUser.uid)] || 'Member' }}
              readOnly
            />
          </div>
        )}
      </div>
    );
  }
  
  if (notLoggedIn) {
    return (
      <div style={{ minHeight: '50vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '2rem' }}>
        <div style={{ maxWidth: '500px', width: '100%', backgroundColor: '#e8f4fd', border: '2px solid #5A9ECB', borderRadius: '12px', padding: '2rem', textAlign: 'center', fontFamily: 'Nunito, sans-serif' }}>
          <h2 style={{ fontSize: '1.5rem', fontWeight: '700', color: '#1a5276', marginBottom: '1rem' }}>Log In to View This Match</h2>
          <p style={{ fontSize: '1rem', color: '#2c3e50', lineHeight: '1.6', marginBottom: '1.5rem' }}>You need to be logged in to view match details.</p>
          <Link to="/login" style={{ display: 'inline-block', backgroundColor: '#5A9ECB', color: 'white', fontWeight: '600', padding: '0.75rem 2rem', border: 'none', borderRadius: '6px', fontSize: '1rem', textDecoration: 'none', fontFamily: 'Nunito, sans-serif' }}>Go to Login</Link>
        </div>
      </div>
    );
  }

  if (!matchPedal || !myMatchingPedal) return <div className='p-4'>Loading match details...</div>;

  console.log('🎯 MATCH DETAILS RENDERING - myUserData:', myUserData);
  console.log('🎯 MATCH DETAILS RENDERING - theirUserData:', theirUserData);

  return (
    <>
      <style>{`
        /* Desktop: same column as the offer page (.offer-page-tile-column in
           OfferPage.jsx: half the viewport plus 2rem, never under 832px) and
           the same tile treatment (photo fills the card, square). Before
           2026-11-01 this page sat in a 620px column with fixed 220px photos
           and looked small next to the offer page it hands off to. Mobile
           rules below are untouched. */
        @media (min-width: 769px) {
          .match-page-column {
            /* min(): never wider than the viewport, so an 800px window no
               longer scrolls sideways (2026-11-01 review); same fix applied
               to the offer page. */
            width: min(calc(50% + 2rem), 100%) !important;
            min-width: min(calc(800px + 2rem), 100%) !important;
            max-width: none !important;
            margin-left: auto !important;
            margin-right: auto !important;
            box-sizing: border-box;
          }
          /* Same header as the offer page on desktop: left-aligned, 2.25rem
             (.offer-page-header-title). Centered at 1.75rem stays for mobile. */
          .match-page-title {
            text-align: left !important;
            font-size: 2.25rem !important;
            letter-spacing: -0.025em;
          }
          .match-cards-row {
            gap: 1.5rem !important;
          }
          /* Cards share the outer edges of the value box below them (Jason,
             2026-10-20). */
          .match-pedal-card {
            max-width: none;
          }
          .match-pedal-photo-link {
            width: 100% !important;
          }
          .match-pedal-card img.pedal-img {
            width: 100% !important;
            height: auto !important;
            aspect-ratio: 1;
          }
          .match-bottom-section {
            max-width: none;
          }
        }
        
        /* Mobile */
        @media (max-width: 768px) {
          .match-details-page {
            padding: 0 0.5rem !important;
          }
          .match-cards-row {
            gap: 0.75rem !important;
          }
          .match-pedal-card {
            flex: 1 1 calc(50% - 0.375rem) !important;
            max-width: calc(50% - 0.375rem) !important;
          }
          .match-pedal-card img.pedal-img {
            width: 140px !important;
            height: 140px !important;
          }
          .match-pedal-name {
            font-size: 0.85rem !important;
          }
          .match-user-info-text {
            font-size: 0.8rem !important;
          }
          .match-user-tier-line {
            font-size: 0.65rem !important;
          }
          .match-bottom-section {
            width: 100% !important;
          }
        }
      `}</style>
      <div className="match-details-page" style={{ backgroundColor: '#F7F3EB', minHeight: 'calc(100vh - var(--navbar-height, 125px))', padding: '0 1rem' }}>
      {/* BottomTabBar adds body { padding-bottom: 150px } on mobile to clear the
          fixed tab bar. Pin a 150px beige stripe to the BOTTOM of the viewport
          (background-attachment: fixed) so only that band is tinted — the area
          near the navbar stays white. Scoped to this component's lifetime. */}
      <style jsx>{`
        body {
          background:
            linear-gradient(to bottom,
              #ffffff 0%,
              #ffffff calc(100% - 150px),
              #F7F3EB calc(100% - 150px),
              #F7F3EB 100%) fixed !important;
        }
      `}</style>
      {/* 620px is the phone/tablet width; the desktop rule above widens this
          column to the offer page's (.offer-page-tile-column) so the two pages
          sit at the same width with the same tile size (owner, 2026-11-01). */}
      <div className="match-page-column" style={{ padding: '1rem 0', maxWidth: '620px', margin: '0 auto' }}>
        <h2 className='font-bold text-center mb-6 match-page-title' style={{ fontSize: '1.75rem' }}>Match Details</h2>

        {/* Pedal Cards Row */}
        <div className="match-cards-row" style={{ display: 'flex', justifyContent: 'center', gap: '1rem', marginBottom: '1rem' }}>

          {/* Your Pedal Card */}
          <div className="match-pedal-card" style={{
            backgroundColor: 'white',
            borderRadius: '12px',
            padding: '1rem',
            boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
            flex: '1',
            textAlign: 'left'
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '12px' }}>
              <div style={{ position: 'relative', width: '32px', height: '32px', flexShrink: 0 }}>
                <img src={myUserData.photoURL || '/images/default-avatar.png'} alt="avatar"
                  style={{ width: '32px', height: '32px', borderRadius: '50%', objectFit: 'cover', border: '1px solid #e5e7eb' }} />
                {getMembershipProfileBadge(myUserData.membershipTier)}
              </div>
              <div style={{ textAlign: 'left' }}>
                <div className="match-user-info-text" style={{ fontWeight: '700', fontSize: '0.9rem', color: '#1f2937' }}>{myUserData.username}</div>
                <div className="match-user-tier-line" style={{ fontSize: '0.75rem', color: '#6b7280', display: 'flex', alignItems: 'center', gap: '4px', flexWrap: 'wrap' }}>
                  <span>{getMembershipTierText(myUserData.membershipTier)}</span>
                  <span>·</span>
                  <span style={{ color: '#f59e0b' }}>★</span>
                  <span style={{ fontWeight: '600', color: '#374151' }}>{myUserData.averageRating > 0 ? myUserData.averageRating.toFixed(1) : '—'}</span>
                  {myUserData.badge !== null && myUserData.badge !== undefined && (
                    <span>({myUserData.badge})</span>
                  )}
                </div>
              </div>
            </div>

            <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '10px' }}>
              {/* The photo taps through to the listing, same destination as the
                  "View listing" link below it (owner, 2026-11-01; mirrors the
                  offer page tiles). Photo only, so the boundary is the square. */}
              <Link className="match-pedal-photo-link" to={`/listing/${myMatchingPedal.id}?from=match`} aria-label={`View listing: ${myMatchingPedal.make} ${myMatchingPedal.model}`}
                style={{ display: 'block', lineHeight: 0, borderRadius: '8px', overflow: 'hidden' }}>
                {myMatchingPedal.images?.top ? (
                  <img className="pedal-img" src={myMatchingPedal.images.top} alt="your pedal"
                    style={{ width: '200px', height: '200px', objectFit: 'cover', borderRadius: '8px' }} />
                ) : (
                  <img className="pedal-img" src={placeholderFor(myMatchingPedal).url} alt="Photos coming" onError={(e) => { if (!e.currentTarget.src.endsWith(SKETCH_PLACEHOLDER_URL)) e.currentTarget.src = SKETCH_PLACEHOLDER_URL; }}
                    style={{ width: '200px', height: '200px', objectFit: 'cover', borderRadius: '8px', opacity: 0.85 }} />
                )}
              </Link>
            </div>

            <div className="match-pedal-name" style={{ fontWeight: '700', fontSize: '1rem', marginBottom: '2px' }}>
              <span style={{ color: '#1f2937' }}>{myMatchingPedal.make}</span>{' '}
              <span style={{ color: '#6b7280' }}>{myMatchingPedal.model}</span>
            </div>
            <div style={{ fontSize: '0.8rem', color: '#6b7280', marginBottom: '4px' }}>Condition: {myMatchingPedal.condition}</div>
            <div style={{ fontWeight: '700', fontSize: '1.25rem', color: '#1f2937', marginBottom: '6px' }}>${myMatchingPedal.price}</div>
            <Link to={`/listing/${myMatchingPedal.id}?from=match`} style={{ color: '#5A9ECB', fontSize: '0.85rem', textDecoration: 'none' }}>
              View listing →
            </Link>
          </div>

          {/* Matched Pedal Card */}
          <div className="match-pedal-card" style={{
            backgroundColor: 'white',
            borderRadius: '12px',
            padding: '1rem',
            border: '2px dashed #C9A227',
            flex: '1',
            textAlign: 'left',
            position: 'relative'
          }}>
            <div style={{
              position: 'absolute',
              top: '-1px',
              right: '12px',
              backgroundColor: '#fef3c7',
              color: '#92400e',
              fontSize: '0.65rem',
              fontWeight: '700',
              padding: '2px 8px',
              borderRadius: '0 0 6px 6px',
              letterSpacing: '0.05em',
              textTransform: 'uppercase',
              border: '1px solid #C9A227',
              borderTop: 'none'
            }}>
              MATCHED PEDAL
            </div>

            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '12px' }}>
              <button onClick={() => navigate(`/profile/${theirUserId}`)} style={{ position: 'relative', width: '32px', height: '32px', flexShrink: 0, background: 'none', border: 'none', padding: 0, cursor: 'pointer' }}>
                <img src={theirUserData.photoURL || '/images/default-avatar.png'} alt="avatar"
                  style={{ width: '32px', height: '32px', borderRadius: '50%', objectFit: 'cover', border: '1px solid #e5e7eb' }} />
                {getMembershipProfileBadge(theirUserData.membershipTier)}
              </button>
              <div style={{ textAlign: 'left' }}>
                <button onClick={() => navigate(`/profile/${theirUserId}`)}
                  className="match-user-info-text"
                  style={{ fontWeight: '700', fontSize: '0.9rem', color: '#1f2937', background: 'none', border: 'none', padding: 0, cursor: 'pointer', fontFamily: 'Nunito, sans-serif' }}
                  onMouseEnter={(e) => e.target.style.textDecoration = 'underline'}
                  onMouseLeave={(e) => e.target.style.textDecoration = 'none'}
                >
                  {theirUserData.username}
                </button>
                <div className="match-user-tier-line" style={{ fontSize: '0.75rem', color: '#6b7280', display: 'flex', alignItems: 'center', gap: '4px', flexWrap: 'wrap' }}>
                  <span>{getMembershipTierText(theirUserData.membershipTier)}</span>
                  <span>·</span>
                  <span style={{ color: '#f59e0b' }}>★</span>
                  <span style={{ fontWeight: '600', color: '#374151' }}>{theirUserData.averageRating > 0 ? theirUserData.averageRating.toFixed(1) : '—'}</span>
                  {theirUserData.badge !== null && theirUserData.badge !== undefined && (
                    <span>({theirUserData.badge})</span>
                  )}
                </div>
              </div>
            </div>

            <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '10px' }}>
              {/* The photo taps through to the listing, same destination as the
                  "View listing" link below it (owner, 2026-11-01; mirrors the
                  offer page tiles). Photo only, so the boundary is the square. */}
              <Link className="match-pedal-photo-link" to={`/listing/${matchPedal.id}?from=match`} aria-label={`View listing: ${matchPedal.make} ${matchPedal.model}`}
                style={{ display: 'block', lineHeight: 0, borderRadius: '8px', overflow: 'hidden' }}>
                {matchPedal.images?.top ? (
                  <img className="pedal-img" src={matchPedal.images.top} alt="matched pedal"
                    style={{ width: '200px', height: '200px', objectFit: 'cover', borderRadius: '8px' }} />
                ) : (
                  <img className="pedal-img" src={placeholderFor(matchPedal).url} alt="Photos coming" onError={(e) => { if (!e.currentTarget.src.endsWith(SKETCH_PLACEHOLDER_URL)) e.currentTarget.src = SKETCH_PLACEHOLDER_URL; }}
                    style={{ width: '200px', height: '200px', objectFit: 'cover', borderRadius: '8px', opacity: 0.85 }} />
                )}
              </Link>
            </div>

            <div className="match-pedal-name" style={{ fontWeight: '700', fontSize: '1rem', marginBottom: '2px' }}>
              <span style={{ color: '#1f2937' }}>{matchPedal.make}</span>{' '}
              <span style={{ color: '#6b7280' }}>{matchPedal.model}</span>
            </div>
            <div style={{ fontSize: '0.8rem', color: '#6b7280', marginBottom: '4px' }}>Condition: {matchPedal.condition}</div>
            <div style={{ fontWeight: '700', fontSize: '1.25rem', color: '#1f2937', marginBottom: '6px' }}>${matchPedal.price}</div>
            <Link to={`/listing/${matchPedal.id}?from=match`} style={{ color: '#5A9ECB', fontSize: '0.85rem', textDecoration: 'none' }}>
              View listing →
            </Link>
          </div>
        </div>

        {/* Value Breakdown + Actions */}
        <div className="match-bottom-section" style={{ margin: '0 auto' }}>

          {/* Value Breakdown Card */}
          <div style={{
            backgroundColor: 'white',
            borderRadius: '12px',
            padding: '1.25rem',
            boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
            marginBottom: '1rem'
          }}>
            <h4 style={{ fontWeight: '700', fontSize: '1rem', color: '#1f2937', marginBottom: '12px', margin: '0 0 12px 0' }}>Value breakdown</h4>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
              <span style={{ color: '#6b7280', fontSize: '0.9rem' }}>Your pedal{myPedalCount > 1 ? `s (${myPedalCount})` : ''}</span>
              <span style={{ fontWeight: '600', color: '#1f2937', fontSize: '0.9rem' }}>${myTotalPedalValue}</span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '12px' }}>
              <span style={{ color: '#6b7280', fontSize: '0.9rem' }}>Their pedal</span>
              <span style={{ fontWeight: '600', color: '#1f2937', fontSize: '0.9rem' }}>${matchPedal.price}</span>
            </div>
            <div style={{ borderTop: '1px solid #e5e7eb', paddingTop: '12px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span style={{ color: '#9ca3af', fontSize: '0.8rem' }}>By listed prices</span>
              <span style={{ color: balanceSuggestion === 0 ? '#16a34a' : '#C9A227', fontWeight: '700', fontSize: '0.9rem' }}>
                {balanceSuggestion === 0
                  ? 'Even trade!'
                  : `${balanceSuggestion < 0 ? 'Suggested cash offer' : 'Suggested cash ask'}: $${Math.abs(balanceSuggestion)}`}
              </span>
            </div>
            {marketBalance && (
              <div style={{ marginTop: '10px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span style={{ color: '#9ca3af', fontSize: '0.8rem' }}>By Reverb market</span>
                <span style={{ color: getBalanceColors(marketBalance).text, fontWeight: '700', fontSize: '0.9rem' }}>
                  {formatBalanceLabel(marketBalance)}
                </span>
              </div>
            )}
          </div>

          {/* Comments between the two matched members (owner, 2026-11-01):
              talk it through here before anyone sends an offer; the actions follow
              below. Sits on the page background like the offer page thread. */}
          {currentUser && theirUserId && isViewerParty && (
            <div style={{ marginTop: '0.5rem', marginBottom: '1.5rem' }}>
              <MatchCommentThread
                matchKey={matchKeyFor(myMatchingPedal.id, matchPedal.id)}
                currentUserId={currentUser.uid}
                theirUserId={theirUserId}
                myPedal={myMatchingPedal}
                theirPedal={matchPedal}
                myUserData={myUserData}
                theirUserData={theirUserData}
              />
            </div>
          )}

          {/* Read, talk, then act: the thread sits above the decision, with the
              offer page's thin rule between them (owner, 2026-11-01). */}
          {currentUser && theirUserId && isViewerParty && (
            <div style={{ borderBottom: '1px solid #d9dce0', margin: '0 0 1.5rem 0' }} />
          )}

          {!userLoading && !isAddressComplete(shippingAddress) && (
            <p style={{ color: '#dc2626', fontSize: '0.8rem', marginBottom: '0.75rem', lineHeight: '1.4', textAlign: 'center' }}>
              A shipping address must be added to your <a href="/profile" style={{ color: '#dc2626', textDecoration: 'underline' }}>profile</a> before offers can be made.
            </p>
          )}

          {!showOfferForm && (
            <>
              {/* Reassurance copy: low-stakes framing + acknowledges that iteration is normal.
                  Shown above the CTA so it sets context BEFORE the user clicks.
                  Hidden once the form is open — would feel redundant and clutter the workflow. */}
              <p
                style={{
                  textAlign: 'left',
                  margin: '0 0 10px',
                  fontSize: '0.85rem',
                  color: '#6B7280',
                  fontFamily: 'Nunito, sans-serif',
                  lineHeight: '1.4'
                }}
              >
                Sending an offer starts the conversation.{' '}
                <a
                  href="/how-it-works#trade-matches"
                  style={{
                    color: '#5A9ECB',
                    textDecoration: 'underline',
                    fontWeight: 600,
                    whiteSpace: 'nowrap'
                  }}
                >
                  How to trade →
                </a>
              </p>
              <button
                onClick={() => {
                  void recordOfferIntentEvent(OFFER_INTENT_KINDS.MATCH_CTA_TRADE, {
                    matchId: `${myMatchingPedal.id}_${matchPedal.id}`,
                    listingId: matchPedal.id,
                  });
                  setShowOfferForm(true);
                }}
                style={{
                  backgroundColor: '#C9A227',
                  color: 'white',
                  border: 'none',
                  borderRadius: '9999px',
                  padding: '14px 24px',
                  fontFamily: 'Nunito, sans-serif',
                  fontWeight: 'bold',
                  fontSize: '1rem',
                  cursor: 'pointer',
                  width: '100%',
                  marginBottom: '10px'
                }}
                onMouseEnter={(e) => e.target.style.opacity = '0.85'}
                onMouseLeave={(e) => e.target.style.opacity = '1'}
              >
                Make trade offer
              </button>
            </>
          )}

          {showOfferForm && (
            <div style={{ marginBottom: '10px' }}>
              <TradeOfferForm
                matchId={`${myMatchingPedal.id}_${matchPedal.id}`}
                fromPedalId={myMatchingPedal.id}
                toPedalId={matchPedal.id}
                toOwnerId={matchPedal.ownerId}
                ownerName={theirUserData.username}
                ownerLastActiveWeek={theirUserData.lastActiveWeek}
                onCancel={() => setShowOfferForm(false)}
                onAdditionalPedalsChange={(ids, prices, pedals) => {
                  const additionalValue = prices.reduce((sum, p) => sum + p, 0);
                  const myTotalValue = Number(myMatchingPedal.price) + additionalValue;
                  setBalanceSuggestion(myTotalValue - Number(matchPedal.price));
                  setMyTotalPedalValue(myTotalValue);
                  setMyPedalCount(1 + ids.length);
                  setAdditionalPedals(pedals || []);
                }}
              />
            </div>
          )}

          {isSaved ? (
            <button
              onClick={handleUnsaveMatch}
              style={{
                backgroundColor: 'transparent',
                color: '#374151',
                border: '1.5px solid #d1d5db',
                borderRadius: '9999px',
                padding: '12px 24px',
                fontFamily: 'Nunito, sans-serif',
                fontWeight: '600',
                fontSize: '1rem',
                cursor: 'pointer',
                width: '100%',
                marginBottom: '10px'
              }}
              onMouseEnter={(e) => e.target.style.backgroundColor = '#f3f4f6'}
              onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
            >
              Unsave match
            </button>
          ) : (
            <button
              onClick={handleSaveMatch}
              style={{
                backgroundColor: 'transparent',
                color: '#374151',
                border: '1.5px solid #d1d5db',
                borderRadius: '9999px',
                padding: '12px 24px',
                fontFamily: 'Nunito, sans-serif',
                fontWeight: '600',
                fontSize: '1rem',
                cursor: 'pointer',
                width: '100%',
                marginBottom: '10px'
              }}
              onMouseEnter={(e) => e.target.style.backgroundColor = '#f3f4f6'}
              onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
            >
              Save match
            </button>
          )}

          <div style={{ textAlign: 'left', marginTop: '8px' }}>
            <Link to='/matches' className='hover:underline text-xs' style={{ color: '#5A9ECB' }}>
              ← Back to Matches
            </Link>
          </div>
        </div>

      {/* Fixed gap below content */}
      <div style={{ height: '60px' }}></div>
      
      {/* Footer */}
      <div className="bg-gray-100 border-t border-gray-200 py-4" style={{ paddingBottom: '10px' }}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <p className="text-sm text-gray-600">
              Need help or found a bug?{' '}
              <button 
                onClick={() => openContact({ category: 'support' })}
                className="hover:underline"
                style={{ 
                  color: '#5A9ECB',
                  background: 'none',
                  border: 'none',
                  padding: 0,
                  font: 'inherit',
                  cursor: 'pointer'
                }}
              >
                Contact PXC Support
              </button>
            </p>
          </div>
        </div>
      </div>
      </div>

      </div>
    </>
  );
};

export default MatchDetails;
